'use strict';

let jsonop = require('jsonop');

module.exports = class Index {
	constructor (options) {
		this.data = {};
		this._options = options;
		this._watches = {};
	}

	put(items) {

	}

	get(id) {
	}

	watch(id, callback) {}

	query(id, callback) {
		const unwatch = this.watch(id, result => {
			unwatch();
			callback(result);
		});
	}
};
